/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDrsCheck.ts                      *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/drs-check";

export class AutogenModelDrsCheck<RowType extends ModelRow> extends Endpoint<RowType, RowDrsCheckFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDrsCheck extends ModelRow<RowDrsCheckFields> {
	constructor(values?: Partial<RowDrsCheckFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDrsCheckFields {
	amount: number;
	amount_c: string;
	amount_d: Date;
	amount_n: number;
	amount_r: number;
	bank_account_id: string;
	check_date: Date;
	check_number: string;
	clear_date: Date;
	clear_source: string;
	company_id: string;
	entered_user_id: string;
	factoring_company_id: string;
	id: string;
	outstand_stmt_date: Date;
	payee_address1: string;
	payee_address2: string;
	payee_address3: string;
	payee_city: string;
	payee_id: string;
	payee_name: string;
	payee_state: string;
	payee_zip: string;
	pos_pay_export: string;
	pos_pay_export_void: string;
	post_key: string;
	post_module: string;
	source_code: string;
	stmt_date: Date;
	void_date: Date;
}

